import { useRef, useState, useEffect } from "react";
import styles from "./Pulses.module.scss";
import RippleSVG from "../assets/pulses/ripple.svg";

export const Pulses = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);
  const [isRippling, setIsRippling] = useState(true);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        const scaleFactor = Math.min(width, height) / 500; // 500 is the original width of the static-sized component
        setScale(scaleFactor);
      }
    });

    if (wrapperRef.current?.parentElement) {
      resizeObserver.observe(wrapperRef.current.parentElement);
    }

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div
      ref={wrapperRef}
      style={{ transform: `scale(${scale})`, transformOrigin: "center center" }}
    >
      <div className={styles.pulses}>
        <div className={styles.top}></div>
        <div className={styles.right}></div>
        <div className={styles.bottom}></div>
        <div className={styles.left}></div>
        {isRippling && (
          <>
            <img
              src={RippleSVG}
              alt="Ripple"
              className={styles.ripple}
              onAnimationEnd={() => {
                setIsRippling(false);
                setTimeout(() => setIsRippling(true), 500);
              }}
            />
          </>
        )}
      </div>
    </div>
  );
};
